import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function Topbar({ isMobile = false, onMenuClick }) {
    const { user, logout } = useAuth();

    return (
        <Box
            sx={{
                height: { xs: 56, sm: 70 },
                background: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: { xs: 2, sm: 3 },
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {isMobile && (
                    <IconButton
                        onClick={onMenuClick}
                        aria-label="Abrir menu"
                        edge="start"
                        sx={{ mr: 0.5 }}
                    >
                        <MenuIcon />
                    </IconButton>
                )}
                <Typography variant="h6" sx={{ fontWeight: 700, fontSize: { xs: "1rem", sm: "1.25rem" } }}>
                    Painel Admin
                </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 0.75, sm: 1.5 }, flexWrap: "wrap", justifyContent: "flex-end" }}>
                <Typography sx={{ display: { xs: "none", sm: "block" } }}>
                    Olá, {user.firstName} {user.lastName}
                </Typography>

                <Button variant="text" size="small" component={Link} to="/" sx={{ display: { xs: "none", md: "inline-flex" } }}>
                    Loja
                </Button>
                <Button variant="text" size="small" component={Link} to="/minha-conta">
                    Minha conta
                </Button>
                <Button variant="text" size="small" component={Link} to="/meus-pedidos">
                    Meus pedidos
                </Button>

                <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                        logout();
                        window.location.href = "/auth";
                    }}
                >
                    Sair
                </Button>
            </Box>
        </Box>
    );
}
